<template>
    <div class="service-detail">
        <main class="main" ref="main">

        </main>
    </div>
</template>

<script>
    import { customerServiceDetail } from '../../api/api.js'
    export default {
        name: 'MserverDetail',
        mounted() {
            customerServiceDetail({ id: this.$route.params.id }).then(res => {
                if (res.data.status === 1) {
                    this.$refs.main.innerHTML = res.data.data.content;
                    var imgs = document.getElementsByTagName('img');
                    for (var i in imgs) {
                        var img = imgs[i];
                        img.style.width = '100%';
                        img.style.height = 'auto';
                    }
                } else {

                }
            })
        },
        data() {
            return {

            };
        }
    }
</script>

<style scoped>
    .main {
        padding: 0 2%;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MserverDetail.vue